import { Suspense, lazy } from 'react';

import { useDemoPersonas } from '../queries/useDemoPersonas';

/**
 * Jedyny punkt montażu paska demo (pakiet demo 2026-08-18).
 *
 * ⭐ Zero if-ologii w ekranach produktu: o wszystkim decyduje odpowiedź serwera
 * (endpoint person = sonda; cztery bramki liczy backend). U zwykłego tenanta
 * sonda daje 404 → `null` → poniższy import dynamiczny NIGDY się nie wykonuje,
 * więc chunk paska nie jest nawet pobierany.
 */
const DemoPersonaBar = lazy(() =>
  import('./DemoPersonaBar').then((module) => ({ default: module.DemoPersonaBar })),
);

export function DemoGate() {
  const personas = useDemoPersonas();

  // Pending i błąd wyglądają jak „nie-demo": pasek jest warstwą dodatkową,
  // a rysowanie czegokolwiek, zanim serwer potwierdzi demo, byłoby zgadywaniem.
  if (!personas.data) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <DemoPersonaBar data={personas.data} />
    </Suspense>
  );
}
